import { useTranslation } from 'react-i18next';
import {
  PerfectButtonHoverVariants,
} from '../../Common/Buttons/perfect-base-button/perfect-base-button.enums';
import STRING_KEYS from '../../../language/keys';
import Dialog from '../base-dialog/base-dialog.component';
import {
  ActionButton,
  DialogBodySubTitle,
  DialogBodyTitle,
  DialogHeaderTitle,
  EmojiContainer,
  FooterContainer,
  HeaderContainer,
} from './start-trial-success-dialog.styled';

export const StartTrialSuccessDialog = ({
  isDialogOpen,
  actionHandler,
  closeHandler,
}: StartTrialSuccessDialogProps): JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Dialog
      isOpen={ isDialogOpen }
      onClose={ closeHandler }
      widthSize="520px"
      portalUniqueId="StartTrialSuccessDialog"
    >
      <HeaderContainer>
        <DialogHeaderTitle>{ translate(STRING_KEYS.TRIAL_START_SUCCESS_DIALOG.HEADER_TITLE) }</DialogHeaderTitle>
        <EmojiContainer>{ translate(STRING_KEYS.TRIAL_START_SUCCESS_DIALOG.HEADER_EMOJI) }</EmojiContainer>
        <DialogBodyTitle>{ translate(STRING_KEYS.TRIAL_START_SUCCESS_DIALOG.BODY_TITLE) }</DialogBodyTitle>
        <DialogBodySubTitle>{ translate(STRING_KEYS.TRIAL_START_SUCCESS_DIALOG.BODY_SUB_TITLE) }</DialogBodySubTitle>
      </HeaderContainer>
      <FooterContainer>
        <ActionButton
          hoverVariant={ PerfectButtonHoverVariants.Grow }
          onClick={ actionHandler }
        >
          { translate(STRING_KEYS.TRIAL_START_SUCCESS_DIALOG.BUTTON_TITLE) }
        </ActionButton>
      </FooterContainer>
    </Dialog>
  );
};
